import * as React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  TextField,
  Snackbar,
  Alert
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import GlobalConfigService from '../../../services/global-config.service';

export default function ConfigList() {
  const [configs, setConfigs] = React.useState([]);
  const [editingId, setEditingId] = React.useState(null);
  const [editValue, setEditValue] = React.useState('');
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: '',
    severity: 'success'
  });

  React.useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = async () => {
    try {
      const response = await GlobalConfigService.list();
      setConfigs(response);
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erreur lors du chargement des configurations',
        severity: 'error'
      });
    }
  };

  const handleEdit = (config) => {
    setEditingId(config.id);
    setEditValue(config.value);
  };

  const handleSave = async (config) => {
    try {
      await GlobalConfigService.update({
        ...config,
        value: editValue
      });
      setEditingId(null);
      await fetchConfigs();
      setSnackbar({
        open: true,
        message: 'Configuration mise à jour avec succès',
        severity: 'success'
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erreur lors de la mise à jour',
        severity: 'error'
      });
    }
  };

  const handleKeyPress = (event, config) => {
    if (event.key === 'Enter') {
      handleSave(config);
    } else if (event.key === 'Escape') {
      setEditingId(null);
    }
  };

  return (
    <Box sx={{ width: '100%', backgroundColor: '#f8f9fa' }}>
      <Paper sx={{ width: '100%', mb: 2, borderRadius: '12px' }}>
        <Typography
          variant="h6"
          sx={{
            p: 2,
            borderBottom: '1px solid #f0f0f0',
            fontWeight: 'bold'
          }}
        >
          Configurations Globales
        </Typography>

        <TableContainer>
          <Table sx={{ minWidth: 750 }}>
            <TableHead sx={{ backgroundColor: '#f8f9fa' }}>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Valeur</TableCell>
                <TableCell>Type</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {configs.map((config) => (
                <TableRow key={config.id} hover>
                  <TableCell>{config.name}</TableCell>
                  <TableCell>
                    {editingId === config.id ? (
                      <TextField
                        fullWidth
                        size="small"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        onKeyDown={(e) => handleKeyPress(e, config)}
                        onBlur={() => handleSave(config)}
                        autoFocus
                      />
                    ) : (
                      config.value
                    )}
                  </TableCell>
                  <TableCell>{config.type}</TableCell>
                  <TableCell align="right">
                    <IconButton 
                      onClick={() => handleEdit(config)}
                      sx={{ color: 'orange' }}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
} 